import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Smart back navigation hook that intelligently handles back navigation
 * Falls back to a default path if there's no history
 * 
 * @param defaultPath - The fallback path to navigate to if no history exists
 * @returns A function to handle smart back navigation
 */
export const useSmartBack = (defaultPath: string = '/') => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleBack = () => {
    // Check if there's a previous page in history
    // location.key will be 'default' on the first page visit
    if (window.history.length > 1 && location.key !== 'default') {
      navigate(-1);
    } else {
      // Fallback to default path if no history
      navigate(defaultPath);
    }
  };
  
  return handleBack;
};
